function calculateWaveSpeed(period) {
  return (9.82 * period) / (2 * 3.142);
}

function calculateAnimationDuration(period) {
  return Math.round(500 / calculateWaveSpeed(period) / 2);
}

function calculateWaveLength(period) {
  return Math.round((period * calculateWaveSpeed(period)) / 2);
}

function calculateWaveHeight(height) {
  const ratio = (Math.abs(height) / 10.0) ** 0.5;
  if (ratio >= 1.0) {
    return 1.0;
  }
  return ratio;
}

function calculateWaveWidth(period, sheletered) {
  if (period < 8) {
    return sheletered ? `${'-'}${0}${'.'}${period}` : `${0}${'.'}${period}`;
  }
  return sheletered ? -1 : 1;
}

function calculateWindAnimationDuration(windSpeed) {
  return Math.round(500 / (windSpeed / 0.44704));
}

export {
  calculateWaveSpeed,
  calculateAnimationDuration,
  calculateWaveLength,
  calculateWaveHeight,
  calculateWaveWidth,
  calculateWindAnimationDuration,
};
